const KegsEndpoint = {
  index () {
    return {
      url: '/kegs',
      method: 'GET',
    }
  }
}

export default KegsEndpoint



// WEBPACK FOOTER //
// ./src/persistence/KegEndpoint.js